import React from 'react';
import { Award, DollarSign, Clock, Shield, CheckCircle } from 'lucide-react';

const NewWhyChooseUs = () => {
  const reasons = [
    {
      icon: Award,
      title: 'Experienced Tilers',
      description: 'Our skilled team brings years of expertise to every project',
    },
    {
      icon: Shield,
      title: 'High-Quality Materials',
      description: 'We use only premium tiles and materials for lasting results',
    },
    {
      icon: DollarSign,
      title: 'Affordable Pricing',
      description: 'Competitive rates without compromising on quality',
    },
    {
      icon: Clock,
      title: 'Reliable and On-Time Service',
      description: 'We respect your time and complete projects as scheduled',
    },
    {
      icon: CheckCircle,
      title: 'Clean and Professional Work',
      description: 'Meticulous attention to detail and thorough site cleanup',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Evershine Services?
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div
                key={index}
                className="text-center p-8 rounded-lg hover:bg-gray-50 transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                  <IconComponent className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
                <p className="text-gray-600 leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NewWhyChooseUs;